import React, { useState, useEffect, useRef } from "react";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import axios from "axios";
import 'quill/dist/quill.snow.css'
import { useNavigate, useParams } from "react-router-dom";

// Soru Tipleri Componentleri
import Choice from "../QuestionListTypes/Choice"
import Match from "../QuestionListTypes/Match"
import VideoContent from "../QuestionListTypes/VideoContent"
import Write from "../QuestionListTypes/Write"
import RealMatch from "../QuestionListTypes/RealMatch"
import TrueFalse from "../QuestionListTypes/TrueFalse"
import Sentence from "../QuestionListTypes/Sentence"
import Link from "../QuestionListTypes/Link"


export const QuestionListBySubject = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [msg, setMsg] = useState([]);
    const [indexx, setIndexx] = useState('');
    const [subject, setSubject] = useState(null);
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const params = useParams();
    const navigate = useNavigate();
    const [showScrollTop, setShowScrollTop] = useState(false); // YENİ: Scroll butonunun görünürlüğünü tutacak state
    // DRAG & DROP REFERANSLARI
    const dragItem = useRef(null);
    const dragOverItem = useRef(null);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 300) {
                setShowScrollTop(true);
            } else {
                setShowScrollTop(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };
    // ==========================================
    // 1. VERİLERİ ÇEKME
    // ==========================================
    useEffect(() => {
        const fetchAllData = async () => {
            setLoading(true);
            try {
                const headers = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + user.token
                };

                const subjectRes = await axios.get("https://api.heryerdeingilizce.com/api/admin/SubjectManager/GetById", {
                    headers: headers,
                    params: { id: params["subject"] }
                });

                if (subjectRes.data.success) {
                    setSubject(subjectRes.data.data);
                }

                const questionsRes = await axios.get("https://api.heryerdeingilizce.com/api/admin/ContentManager/GetListBySubject", {
                    headers: headers,
                    params: { subjectId: params["subject"] }
                });

                console.log("Çekilen Sorular:", questionsRes.data.data); console.log("Çekilen Sorular:", questionsRes.data.data);

                if (questionsRes.data.success) {
                    let tempArray = [];
                    for (let i = 0; i < questionsRes.data.data.length; i++) {
                        const item = questionsRes.data.data[i];
                        if (item.isDeleted === false) {
                            tempArray.push({
                                ...item,
                                originalSortId: item.sortId
                            });
                        }
                    }

                    tempArray.sort((a, b) => a.sortId - b.sortId);
                    setData(tempArray);
                } else {
                    setMsg(questionsRes.data.message);
                }

            } catch (err) {
                setMsg("Veriler yüklenirken bir hata oluştu.");
                console.error(err);
            }
            setLoading(false);
        };

        fetchAllData();
    }, [params, user.token]);

    // ==========================================
    // 2. ORTAK KAYDETME FONKSİYONU (Backend)
    // ==========================================
    const saveUpdatedOrder = async (updatedData) => {
        const changedQuestions = updatedData.filter(item => item.sortId !== item.originalSortId);

        if (changedQuestions.length > 0) {
            Swal.fire({
                title: 'Sıralama Güncelleniyor...',
                html: `Lütfen bekleyiniz.<br/><br/><b>0 / ${changedQuestions.length}</b> soru güncellendi.`,
                allowOutsideClick: false,
                didOpen: () => { Swal.showLoading(); }
            });

            try {
                let completedCount = 0;
                for (const item of changedQuestions) {
                    const payload = { ...item };
                    delete payload.originalSortId;

                    await axios.post("https://api.heryerdeingilizce.com/api/admin/ContentManager/Update", payload, {
                        headers: { 'Authorization': 'Bearer ' + user.token }
                    });

                    completedCount++;
                    Swal.update({
                        html: `Lütfen bekleyiniz.<br/><br/><b>${completedCount} / ${changedQuestions.length}</b> soru güncellendi.`
                    });
                }

                Swal.fire({ icon: 'success', title: 'Başarılı!', timer: 1000, showConfirmButton: false });
                setData(updatedData.map(item => ({ ...item, originalSortId: item.sortId })));

            } catch (error) {
                Swal.fire("Hata", "Sıralama güncellenemedi.", "error");
                setData(data); // Hata durumunda state'i geri al
            }
        } else {
            setData(updatedData);
        }
    };

    // ==========================================
    // 3. DRAG & DROP (SÜRÜKLE BIRAK) OLAYLARI
    // ==========================================
    const handleDragStart = (e, index) => {
        dragItem.current = index;
    };

    const handleDragOver = (e, index) => {
        e.preventDefault();
        dragOverItem.current = index;
    };
    // ==========================================
    // 5. SORU SİLME VE SIRALAMA GÜNCELLEME
    // ==========================================
    const handleDeleteQuestion = async (id) => {
        Swal.fire({
            title: 'Emin misiniz?',
            text: "Bu soruyu silmek istediğinize emin misiniz? İşlem sonrasında altındaki soruların sıralaması (Sort ID) otomatik olarak yukarı kaydırılacaktır.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Evet, Sil!',
            cancelButtonText: 'İptal'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    Swal.fire({
                        title: 'Siliniyor...',
                        allowOutsideClick: false,
                        didOpen: () => { Swal.showLoading(); }
                    });

                    // 1. Backend'e silme isteğini gönder
                    const response = await axios.delete(`https://api.heryerdeingilizce.com/api/admin/ContentManager/Delete/${id}`, {
                        headers: { 'Authorization': 'Bearer ' + user.token }
                    });

                    if (response.data.success) {
                        // 2. Silinen soruyu mevcut lokal listeden çıkar
                        let _data = data.filter(item => item.id !== id);

                        // 3. Kalan elemanların sortId'lerini bulundukları index'e göre (idx + 1) yeniden düzenle
                        const updatedData = _data.map((item, idx) => ({
                            ...item,
                            sortId: idx + 1
                        }));

                        // 4. Sıralamada değişiklik varsa mevcut saveUpdatedOrder'ı tetikle
                        const changedQuestions = updatedData.filter(item => item.sortId !== item.originalSortId);

                        if (changedQuestions.length > 0) {
                            // saveUpdatedOrder sunucuyu günceller ve kendi "Sıralama Güncelleniyor / Başarılı" Swal'ini gösterir.
                            await saveUpdatedOrder(updatedData);
                        } else {
                            // Eğer dizinin EN SONUNDAKİ soru silindiyse, diğerlerinin sıralaması değişmemiştir. Sadece state'i ezeriz.
                            setData(updatedData);
                            Swal.fire({ icon: 'success', title: 'Soru Başarıyla Silindi!', timer: 1500, showConfirmButton: false });
                        }
                    } else {
                        Swal.fire("Hata", response.data.message || "Silme işlemi başarısız oldu.", "error");
                    }
                } catch (error) {
                    console.error("Silme Hatası:", error);
                    Swal.fire("Hata", "Soru silinirken sunucu kaynaklı bir hata oluştu.", "error");
                }
            }
        });
    };
    const handleDrop = async (e) => {
        e.preventDefault();
        if (dragItem.current === null || dragOverItem.current === null) return;
        if (dragItem.current === dragOverItem.current) return;

        let _data = [...data];
        const draggedItemContent = _data.splice(dragItem.current, 1)[0];
        _data.splice(dragOverItem.current, 0, draggedItemContent);

        const updatedData = _data.map((item, idx) => ({
            ...item,
            sortId: idx + 1
        }));

        await saveUpdatedOrder(updatedData);

        dragItem.current = null;
        dragOverItem.current = null;
    };

    // ==========================================
    // 4. MANUEL SORT ID DEĞİŞTİRME (TEXTBOX)
    // ==========================================
    const handleManualSortChange = async (oldIndex, newSortIdValue) => {
        let newSortId = parseInt(newSortIdValue, 10);

        // Geçersiz bir sayı veya aynı sayı girilirse iptal et
        if (isNaN(newSortId) || newSortId === data[oldIndex].sortId) return;

        // Girilen sayı min-max sınırları dışında kalıyorsa düzelt
        if (newSortId < 1) newSortId = 1;
        if (newSortId > data.length) newSortId = data.length;

        let _data = [...data];

        // İlgili soruyu eski yerinden alıp yeni yerine (index = SortID - 1) taşıyoruz
        const itemToMove = _data.splice(oldIndex, 1)[0];
        _data.splice(newSortId - 1, 0, itemToMove);

        // Yeni sıraya göre tüm ID'leri yeniden numaralandır
        const updatedData = _data.map((item, idx) => ({
            ...item,
            sortId: idx + 1
        }));

        // Kaydetme fonksiyonunu çağır
        await saveUpdatedOrder(updatedData);
    };

    const searchDiv = () => {
        if (!indexx) return;
        const targetElement = document.getElementById(indexx);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth' });
        }
    }

    if (loading) {
        return <div className="text-center" style={{ marginTop: "100px" }}>Yükleniyor...</div>;
    }

    return (
        <div className="container-fluid py-4">
            <div className="text-center mb-4 pb-2 border-bottom">
                {subject && (
                    <>
                        <h1 className="fw-bold text-dark mb-1">{subject.subjectName}</h1>
                        <p className="text-muted small">ID: {subject.id} | Course ID: {subject.courseId}</p>
                    </>
                )}
                Toplam Soru: <strong>{data.length}</strong>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <input
                        type="number"
                        className="form-control d-inline-block shadow-sm"
                        placeholder="SortId'ye git..."
                        value={indexx}
                        onChange={(e) => setIndexx(e.target.value)}
                        style={{ width: '180px' }}
                    />
                    <button className="btn btn-outline-secondary ms-2" onClick={searchDiv}>Git</button>
                </div>
                <a href={"/admin/createquestion/" + params["subject"]} className="btn btn-primary shadow">
                    <i className="pi pi-plus me-2"></i> Yeni Soru Oluştur
                </a>
            </div>
            <div className="question-list" >
                {data.map((dt, index) => {

                    let ContentComponent = null;
                    if (dt['contentType'] === "choice") ContentComponent = <Choice data={dt} />;
                    else if (dt['contentType'] === "match") ContentComponent = <Match data={dt} />;
                    else if (dt['contentType'] === "video") ContentComponent = <VideoContent data={dt} />;
                    else if (dt['contentType'] === "write") ContentComponent = <Write data={dt} />;
                    else if (dt['contentType'] === "sentence") ContentComponent = <Sentence data={dt} />;
                    else if (dt['contentType'] === "realmatch") ContentComponent = <RealMatch data={dt} />;
                    else if (dt['contentType'] === "truefalse") ContentComponent = <TrueFalse data={dt} />;
                    else if (dt['contentType'] === "link") ContentComponent = <Link data={dt} />;

                    if (!ContentComponent) return null;

                    return (
                        <div
                            id={dt.sortId}
                            key={`question-${dt.id}`}
                            draggable
                            onDragStart={(e) => handleDragStart(e, index)}
                            onDragOver={(e) => handleDragOver(e, index)}
                            onDrop={(e) => handleDrop(e)}
                            className="card mb-4 shadow-sm border-2"
                            style={{ cursor: "grab", borderStyle: "dashed" }}
                        >
                            {/* DİKKAT: Textbox ve butonların çalışması için pointerEvents: "auto" eklendi */}
                            <div style={{ textAlign: "center", pointerEvents: "none", marginTop: "10px", marginBottom: "-15px" }}>
                                <h5>
                                    <span style={{ fontSize: "1.5rem", marginRight: "10px", color: "#aaa" }}>≡</span>
                                    {/* {dt.contentType.toUpperCase()} - */} Soru No: {index + 1} |

                                    <strong className="text-danger ms-2 me-1">Sort ID: </strong>
                                    {/* MANUEL SORT ID GİRİŞ KUTUSU (INPUT) */}
                                    <input
                                        key={`input-${dt.id}-${dt.sortId}`} // Güncel değeri otomatik çekmesi için Key
                                        type="number"
                                        defaultValue={dt.sortId}
                                        min="1"
                                        max={data.length}
                                        className="form-control form-control-sm text-center fw-bold text-danger d-inline shadow-sm"
                                        style={{ width: "70px", pointerEvents: "auto" }}
                                        onBlur={(e) => handleManualSortChange(index, e.target.value)}
                                        onKeyDown={(e) => {
                                            // Enter'a basıldığında tetiklenmesi için onBlur'u çağırıyoruz
                                            if (e.key === 'Enter') e.target.blur();
                                        }}
                                    />

                                    &nbsp;&nbsp;&nbsp;
                                    <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning" style={{ pointerEvents: "auto" }}>
                                        Soruyu Yeniden Oluştur
                                    </a>

                                    {/* YENİ EKLENEN SİLME BUTONU */}
                                    &nbsp;&nbsp;&nbsp;
                                    <button
                                        className="btn btn-danger"
                                        style={{ pointerEvents: "auto" }}
                                        onClick={() => handleDeleteQuestion(dt.id)}
                                    >
                                        Soruyu Sil
                                    </button>
                                </h5>
                            </div>

                            <div className="card-body">
                                {ContentComponent}
                            </div>
                        </div>
                    );
                })}
            </div>
            {showScrollTop && (
                <button
                    onClick={scrollToTop}
                    className="btn btn-primary shadow"
                    style={{
                        position: 'fixed',
                        bottom: '40px',
                        right: '40px',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 1000
                    }}
                    title="Yukarı Çık"
                >
                    <i className="pi pi-arrow-up" style={{ fontSize: '1.2rem' }}></i>
                </button>
            )}
        </div>
    );
}

export default QuestionListBySubject;